import styled, { keyframes } from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';

const styleMap = {
  color: props => props.color,
  size: props => props.size,
};

const pulsateKeyframes = keyframes`
  0% {transform: scale(0.1, 0.1); opacity: 0.0;}
  50% {opacity: 1.0;}
  70% {transform: scale(1.5, 1.5); opacity: 0.0;}
`;

const PulseCircle = styled.div`
  width: ${styleMap.size}px;
  height: ${styleMap.size}px;
  background-color: ${styleMap.color};
  border-radius: 50%;
`;

const PulseRing = styled.span`
  border: ${props => props.borderWidth}px solid ${styleMap.color};
  width: ${styleMap.size}px;
  height: ${styleMap.size}px;
  border-radius: 50%;
  display: block;
  animation: ${props => (props.pulsate ? pulsateKeyframes : 'none')};
  animation-duration: 2.5s;
  animation-timing-function: ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
`;

function PulseDot({ color, size, ringColor, ringWidth, className, pulsate }) {
  return (
    <PulseCircle color={color} size={size} className={className}>
      <PulseRing
        color={ringColor || color}
        size={size - ringWidth * 2}
        borderWidth={ringWidth}
        pulsate={pulsate}
      />
    </PulseCircle>
  );
}

PulseDot.propTypes = {
  /** A string the depicts the color in CSS compatible format e.g. '#ffffff' */
  color: PropTypes.string,
  /** Value for the height and width of the component in pixels */
  size: PropTypes.number,
  ringColor: PropTypes.string,
  /** Width of the pulsing ring in pixels */
  ringWidth: PropTypes.number,
  /** Pass through for compatibility with styled components */
  className: PropTypes.string,
  /** Is false whether or not current location is set manually on the map */
  pulsate: PropTypes.bool,
};

PulseDot.defaultProps = {
  color: '#62bd19',
  size: 8,
  ringColor: null,
  ringWidth: 3,
  className: null,
  pulsate: null,
};

export { PulseDot, PulseCircle, PulseRing };
